/*
  Bra collection pages (sections/main-collection.liquid with "InvisiBra bra layout" on). Three jobs, no libraries:

  1. Size buttons, Colour/Style options and "Clear size" are plain links (data-ib-ajax). With the theme's AJAX
     filtering on, hand the click to the filter-container element's own ajaxLoadUrl so the grid, toolbar and count
     refresh in place. Without JS they just navigate.
  2. Close an open Colour/Style dropdown on an outside click or Escape, and keep one open at a time.
  3. "Load more": fetch the next page with the Section Rendering API, append its cards, swap the "You've seen X of Y"
     block for the new one, keep the URL in step and move focus to the first new card. Without JS the button is a
     normal link to page 2.
*/
(function () {
  'use strict';

  var plain = function (e) {
    return !e.defaultPrevented && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
  };
  var filterContainer = function () {
    return document.querySelector('filter-container');
  };

  document.addEventListener('click', function (e) {
    var openDropdowns = document.querySelectorAll('details.ib-dd[open]');
    for (var i = 0; i < openDropdowns.length; i += 1) {
      if (!openDropdowns[i].contains(e.target)) openDropdowns[i].removeAttribute('open');
    }

    var link = e.target.closest && e.target.closest('a[data-ib-ajax]');
    if (link && plain(e)) {
      var fc = filterContainer();
      if (fc && fc.dataset.ajaxFiltering === 'true' && typeof fc.ajaxLoadUrl === 'function') {
        e.preventDefault();
        fc.ajaxLoadUrl(link.href);
      }
      return;
    }

    var more = e.target.closest && e.target.closest('[data-ib-load-more]');
    if (more && plain(e)) {
      e.preventDefault();
      loadMore(more);
    }
  });

  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('details.ib-dd') || !e.target.open) return;
    document.querySelectorAll('details.ib-dd[open]').forEach(function (d) {
      if (d !== e.target) d.removeAttribute('open');
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('details.ib-dd[open]');
    if (!open) return;
    open.removeAttribute('open');
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  function loadMore(button) {
    var fc = filterContainer();
    var grid = document.querySelector('.product-grid--ib');
    if (button.getAttribute('aria-busy') === 'true') return;
    if (!fc || !grid) {
      window.location.href = button.href;
      return;
    }
    button.setAttribute('aria-busy', 'true');

    var url = new URL(button.href, window.location.href);
    url.searchParams.set('section_id', fc.dataset.filterSectionId);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.product-grid--ib > product-block');
        if (!cards.length) throw new Error('No cards in the response');

        var first = null;
        cards.forEach(function (card) {
          var node = document.importNode(card, true);
          grid.appendChild(node);
          if (!first) first = node;
        });

        var oldMore = document.querySelector('[data-ib-more]');
        var newMore = doc.querySelector('[data-ib-more]');
        if (oldMore && newMore) oldMore.replaceWith(document.importNode(newMore, true));
        else if (oldMore) oldMore.remove();

        var target = first && first.querySelector('a.product-link:not([aria-hidden])');
        if (target) target.focus({ preventScroll: true });
        window.history.replaceState(window.history.state, '', button.href);
      })
      .catch(function () {
        window.location.href = button.href;
      });
  }
})();
